export default function useMainButtons() {
  const shadowFilter = (onClickMain) => {
    return {
      transform: onClickMain ? "scale(0.9)" : "scale(1)",
      filter: onClickMain
        ? "drop-shadow(0px 0px 0px rgb(0, 0, 0))"
        : "drop-shadow(0px 0px 4px rgb(70, 70, 70))",
    };
  };
  return { shadowFilter };
}
